<template>
  <div class="content">
    <div class="box-bg">
      <div class="industryList">
        <div class="list-index" v-for="(item, index) in industryList" :index="index" :key="index" @click="to(item.id,item.name)">
          <div class="list-image">
            <img :src="indexurl+item.image" alt="">
          </div>
          <div class="list-name">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      industryList: [],
      indexurl:''
    }
  },
  created() {
    console.log(localStorage.getItem('url'))
    let indexurl = localStorage.getItem('url')
    console.log(indexurl)
    this.indexurl = indexurl
    this.get(indexurl)

  },

  methods: {
    get(url) {
      let that = this
      console.log(url)
      this.$axios({
        method: "GET",
        url: url + "/index.php/api/index/getIndustry",
        data: {}
      })
        .then(function (res) {
          console.log(res.data.data, '成功')
          that.industryList = res.data.data
        })
    },
    to(id,name) {
      this.$router.push({
        path: '/components/information',
        query: {
        id:id,
          name : name
        }
      })
    }
  }
}
</script>

<style scoped>
.box-bg {
position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  padding: 20px;
  box-shadow: 0 0 15px 15px rgba(0, 0, 0, 0.22);
  border-radius: 10px;
  margin: auto;
}

.industryList {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

}

.list-index {
  width: 18%;
  margin-bottom: 20px;
  padding: 5px;
  transition: all 0.5s;

}
.list-index:hover {
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.3);
  margin-top: -10px;
}
.list-image{
  position: relative;
  padding-bottom: 77%;
}

.list-index img {
  width: 100%;
  position: absolute;
  height: 100%;
  object-fit: cover;

}

.list-name {
  text-align: center;
}

/*@media (max-width: 800px) {*/
/*  .box-bg{*/
/*    width: 80%;*/
/*    position: unset;*/
/*    top: unset;*/
/*    left: unset;*/
/*    transform: unset;*/
/*    margin: 20px auto;*/
/*  }*/
/*}*/

@media (max-width:768px) {
  .box-bg{
    position: unset;
    top: unset;
    left: unset;
    transform:unset;
    margin: 20px auto;
  }
  .list-index {
    width: 30%;
  }
}
@media (max-width:480px) {
  .list-index {
    width: 42%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/industry/index.vue